/**
 * JSON-LD serialization that cannot break out of its `<script>` tag.
 *
 * What: `JSON.stringify` with `<` escaped to `<`.
 * Why: Structured data on the marketing pages is built from strings we do not
 * fully control — the school catalog, area copy, partner names taken from a
 * partner's own site. A literal `</script>` inside any of them would close the
 * tag early and turn the rest of the payload into markup. Escaping `<` is
 * enough: JSON strings accept the `<` escape, so the emitted document is
 * still valid JSON-LD to every consumer.
 * When: Update if a marketing page starts emitting structured data through a
 * different serializer.
 */

/** Escape `<` in JSON-LD so authored or catalog-sourced text cannot close the script tag. */
export function safeJsonLd(obj: unknown): string {
  return JSON.stringify(obj).replace(/</g, '\\u003c');
}

export default safeJsonLd;
